"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributes$ = exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributes$outboundSchema = exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributes$inboundSchema = void 0;
exports.fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributesToJSON = fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributesToJSON;
exports.fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributesFromJSON = fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const propertiessoldstatswrapper_js_1 = require("./propertiessoldstatswrapper.js");
/** @internal */
exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributes$inboundSchema = z.object({
    end_date: z.string().datetime({ offset: true }).transform(v => new Date(v)),
    local_authority_code: z.string(),
    local_authority_name: z.string(),
    start_date: z.string().datetime({ offset: true }).transform(v => new Date(v)),
    stats: propertiessoldstatswrapper_js_1.PropertiesSoldStatsWrapper$inboundSchema,
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "end_date": "endDate",
        "local_authority_code": "localAuthorityCode",
        "local_authority_name": "localAuthorityName",
        "start_date": "startDate",
    });
});
/** @internal */
exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributes$outboundSchema = z.object({
    endDate: z.date().transform(v => v.toISOString()),
    localAuthorityCode: z.string(),
    localAuthorityName: z.string(),
    startDate: z.date().transform(v => v.toISOString()),
    stats: propertiessoldstatswrapper_js_1.PropertiesSoldStatsWrapper$outboundSchema,
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        endDate: "end_date",
        localAuthorityCode: "local_authority_code",
        localAuthorityName: "local_authority_name",
        startDate: "start_date",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributes$;
(function (FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributes$) {
    /** @deprecated use `FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributes$inboundSchema` instead. */
    FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributes$.inboundSchema = exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributes$inboundSchema;
    /** @deprecated use `FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributes$outboundSchema` instead. */
    FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributes$.outboundSchema = exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributes$outboundSchema;
})(FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributes$ || (exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributes$ = FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributes$ = {}));
function fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributesToJSON(fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributes) {
    return JSON.stringify(exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributes$outboundSchema
        .parse(fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributes));
}
function fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributes$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetPropertiesSoldResponsesStatsPropertiesSoldAttributes' from JSON`);
}
//# sourceMappingURL=fastapikrakenendpointsstatsmodelssaleslocalauthoritygetpropertiessoldresponsesstatspropertiessoldattributes.js.map